import { useNavigate } from '@tanstack/react-router';
import { Button } from '../../components/ui/button';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-neutral-50">
            <div className="bg-neutral-200 rounded-xl p-8 max-w-2xl w-full text-center border border-neutral-300">
                <img
                    src="/undraw_data-thief_d66l.svg"
                    alt="Page Unauthorized"
                    style={{ width: '50%', maxWidth: '400px' }}
                />
                <h1 className="text-4xl font-bold text-primary my-4">Unauthorized</h1>
                <p className="text-md text-neutral-700 mb-6">
                    You do not have permission to view this page.
                    <br />
                    Please login or contact support if you believe this is an error.
                </p>
                <Button
                    variant="destructive"
                    className="rounded-lg w-full"
                    onClick={() => navigate({ to: '/dashboard' })}
                >
                    Return to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default Unauthorized;
